import styled from 'styled-components';

import { Body } from '@cognite/cogs-core-v11/tokens/typography/typography.tsx';
import { Flex } from '@cognite/cogs-core-v11/components/flex/flex.tsx';

export const Container = styled(Flex).attrs({
  direction: 'column',
})`
  width: 100%;
`;

export const ViewMappingTitle = styled(Body).attrs({
  size: 'x-small',
  strong: true,
})<{
  $isChanged: boolean;
}>`
  ${({ $isChanged }) =>
    $isChanged && 'color: var(--cogs-border--status-warning--strong)'}
`;
